// extracted by mini-css-extract-plugin
module.exports = {"menu":"popout-menu_menu__dxVGu","options":"popout-menu_options__328HW"};